<ng-container *ngIf="showInsightReports$ | async">
  <gh-sub-nav-options class="ml-11px mt-10px mb-10px d-block" [options]="customReportOptions"></gh-sub-nav-options>
  <div class="borderline"></div>
</ng-container>
<gh-default-sub-navigation
  *ngIf="!hideListsFeatureFlag"
  [options]="options"
  [itemsType]="'lists'"
  [favorites]="favorites$ | async"
  [recent]="recents$ | async"
  [suggested]="suggested$ | async"
  [loading]="loading$ | async"
  (markItemAsFavorite)="markItemAsFavorite($event)"
  (unmarkItemAsFavorite)="unmarkItemAsFavorite($event)"></gh-default-sub-navigation>
